import {Box} from "@mui/material";
import type {FC, PropsWithChildren} from "react";

const CenterContainer: FC<PropsWithChildren> = ({children}) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    height="100vh"
    px={2} // padding-inline: 16px
  >
    <Box sx={{maxWidth: 500, width: "100%"}}>{children}</Box>
  </Box>
);

export default CenterContainer;
